import React from 'react';
import { useTranslation } from 'react-i18next';
import EditorialLayout from '@/components/editorial/EditorialLayout';
import { DraftsList } from '@/components/editorial/review/DraftsList';
import { useArticleDrafts } from '@/hooks/useArticleDrafts';

const EditorialReviewPage: React.FC = () => {
  const { t } = useTranslation();
  const { drafts, isLoading, error, approveDraft, rejectDraft } = useArticleDrafts();

  return (
    <EditorialLayout>
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground">Redaksjonell Godkjenning</h1>
          <p className="text-muted-foreground mt-2">
            Gjennomgå og godkjenn AI-genererte artikkelutkast før publisering
          </p>
        </div>

        <DraftsList
          drafts={drafts}
          isLoading={isLoading}
          error={error}
          onApprove={approveDraft}
          onReject={rejectDraft}
        />
      </div>
    </EditorialLayout>
  );
};

export default EditorialReviewPage;
